/**
 * Query used to create RFXQuestion attachment.
 * Below are the list of services that it talks to:
 * AWSSCMRFXService
 */
import { gql } from '@apollo/client';

import { processResponse } from './helper';

export const createRFXQuestionAttachmentMutation = gql`
  mutation createRFXQuestionAttachment(
    $rfxQuestionId: RFXRevisionedIdInput!
    $externalId: String!
    $filename: String!
    $description: String
    $stagingS3Uri: String!
    $documentType: String!
  ) {
    createRFXQuestionAttachment(
      rfxQuestionId: $rfxQuestionId
      externalId: $externalId
      filename: $filename
      description: $description
      stagingS3Uri: $stagingS3Uri
      documentType: $documentType
    ) {
      rfxQuestionId {
        id {
          value
        }
        revision
      }
      externalId
      status
    }
  }
`;

export default function createRFXQuestionAttachment(
    this: any, 
    rfxQuestionRevisionedIdValue: string,
    rfxQuestionRevisionedIdRevision: number,
    externalId: string,
    filename: string,
    description: string,
    stagingS3Uri: string,
    documentType: string) {
  return processResponse(
    this.mutate({
      mutation: createRFXQuestionAttachmentMutation,
      variables: {
        rfxQuestionId: {
          id: {
            value: rfxQuestionRevisionedIdValue
          },
          revision: rfxQuestionRevisionedIdRevision
        },
        externalId: externalId,
        filename: filename,
        description: description,
        stagingS3Uri: stagingS3Uri,
        documentType: documentType
      }
    }),
    'createRFXQuestionAttachment'
  );
}